/**
 * Product compare: checkboxes [data-compare-toggle] on cards add up to 4 products to a list kept
 * in localStorage; a sticky bar links to the compare page (/pages/compare-product?products=a,b).
 */
(() => {
  const KEY = 'bo-compare';
  const MAX = 4;
  const PAGE = '/pages/compare-product';

  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  };
  const write = (items) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch {
      /* storage unavailable: compare still works for this page view */
    }
    window.__boCompare = items;
  };
  const list = () => window.__boCompare || read();

  function bar() {
    let el = document.querySelector('.bo-compare-bar');
    if (!el) {
      el = document.createElement('div');
      el.className = 'bo-compare-bar';
      el.innerHTML =
        '<div class="bo-wrap bo-compare-bar__inner"><ul class="bo-compare-bar__items"></ul>' +
        '<div class="bo-compare-bar__actions"><button type="button" class="bo-compare-bar__clear">Clear</button>' +
        '<a class="bo-btn bo-compare-bar__go" href="#">Compare</a></div></div>';
      document.body.append(el);
      el.querySelector('.bo-compare-bar__clear').addEventListener('click', () => {
        write([]);
        sync();
      });
    }
    return el;
  }

  function sync() {
    const items = list();
    document.querySelectorAll('[data-compare-toggle]').forEach((box) => {
      box.checked = items.some((i) => i.handle === box.dataset.handle);
    });
    const el = bar();
    el.hidden = items.length === 0;
    el.querySelector('.bo-compare-bar__items').innerHTML = items
      .map(
        (i) =>
          `<li><img src="${i.image}" alt=""><span>${i.title}</span>` +
          `<button type="button" aria-label="Remove ${i.title}" data-remove="${i.handle}">×</button></li>`
      )
      .join('');
    el.querySelectorAll('[data-remove]').forEach((b) =>
      b.addEventListener('click', () => {
        write(list().filter((i) => i.handle !== b.dataset.remove));
        sync();
      })
    );
    const go = el.querySelector('.bo-compare-bar__go');
    go.textContent = `Compare (${items.length})`;
    go.href = `${PAGE}?products=${items.map((i) => encodeURIComponent(i.handle)).join(',')}`;
    go.classList.toggle('is-disabled', items.length < 2);
  }

  document.addEventListener('change', (e) => {
    const box = e.target.closest('[data-compare-toggle]');
    if (!box) return;
    let items = list().filter((i) => i.handle !== box.dataset.handle);
    if (box.checked) {
      if (items.length >= MAX) {
        box.checked = false;
        alertMax(box);
        return;
      }
      items.push({ handle: box.dataset.handle, title: box.dataset.title, image: box.dataset.image });
    }
    write(items);
    sync();
  });

  function alertMax(box) {
    const note = document.createElement('span');
    note.className = 'bo-compare-note';
    note.textContent = `Compare up to ${MAX} products`;
    box.closest('label')?.append(note);
    setTimeout(() => note.remove(), 2500);
  }

  document.addEventListener('bo:cards-added', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();

  window.BoCompare = { list, write, sync };
})();
